import { Outlet } from "react-router-dom";
import Navigation from "../navigation/Navigation";

interface Props {
  loading: boolean;
}

const Layout = ({ loading }: Props) => {
  return (
    <>
      <Outlet />
      {!loading && <Navigation />}
    </>
  );
};
export default Layout;
